import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ToggleHideUnfiltered extends Action<StorymapState> {
    public static ACTION_TYPE = 'ToggleHideUnfiltered';

    public constructor() {
        super(ToggleHideUnfiltered.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    const newValue = !state.filterState.hideUnfiltered;
    state.filterState.hideUnfiltered = newValue;

    // Exit focus release if turning hide on (mutual exclusivity)
    if (newValue) {
        for (const release of state.releases) {
            release.isFocused = false;
        }
    } else {
        // Clear newly created card tracking when turning hide off
        state.filterState.newlyCreatedCardIds = [];
    }
};

//@ts-ignore
registerReducer(ToggleHideUnfiltered.ACTION_TYPE, reducer);
